import { FavoritesContent } from "@/components/favorites-content"

export default function FavoritesPage() {
    return <FavoritesContent />
}
